
export default {
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
}
